export const state = () => ({
  alreadySeenPopups: [],
})

export const actions = {
  checkSeenPopup ({ state }, instance) {
    return state.alreadySeenPopups.some(i => i == instance.id)
  },
  async addSeenPopup ({ commit, dispatch }, instance) {
    const alreadySeen = await dispatch('checkSeenPopup', instance)

    if (!alreadySeen) {
      commit('ADD_SEEN_POPUP', instance)
    }
  },
}

export const mutations = {
  ADD_SEEN_POPUP (state, instance) {
    state.alreadySeenPopups.push(instance.id)
  },
}
